import React from 'react'
import Button from '../../common/Button'
import { useFeedback } from '../../context/FeedbackContext'
import PopoutButton from '../../common/popout/PopoutButton'
import { useTranslation } from '../../../lib/i18n'

const ReportAction = ({ type, id, isPopout = false }) => {
  const { openFeedback } = useFeedback()
  const { t } = useTranslation()

  if (!type || !id) return null

  const handleReport = () => {
    openFeedback(
      'content_report',
      { reportable_type: type, reportable_id: id },
      true
    )
  }

  // Get the translated type
  const getTranslatedType = (type) => {
    const typeKey = type?.toLowerCase()
    return t(`profile.reportableTypes.${typeKey}`, typeKey)
  }

  const ButtonComponent = isPopout ? PopoutButton : Button
  const buttonProps = isPopout ? {} : { tiny: true }
  const buttonText = isPopout
    ? t('profile.report')
    : t('profile.reportItem', {
        item: getTranslatedType(type),
      })

  return (
    <ButtonComponent {...buttonProps} onClick={handleReport}>
      {buttonText}
    </ButtonComponent>
  )
}

export default ReportAction
